import { ValueObject } from 'ddd-base';
import { Message } from '@/constants';

export class CloudId extends ValueObject<{ value: string }> {
    public static readonly RULES = [(value: string) => value.length === 11 || '11文字で入力してください。'];

    get value() {
        return this.props.value;
    }

    get isValid() {
        return !CloudId.RULES.some((rule) => rule(this.value) !== true);
    }

    get validationMessage() {
        if (!this.value) {
            return Message.NOT_INPUT_ERROR;
        }

        const result = CloudId.RULES.find((rule) => rule(this.value) !== true);
        if (result) {
            return result(this.value) as string;
        }

        return '';
    }

    /**
     * 実行側のcloudIdを引数のcloudIdで上書きする
     * どちらも値を持っていない場合は空文字で初期化した結果を返す
     */
    join(other: CloudId | undefined) {
        if (!other) {
            return this;
        }
        return new CloudId({ value: other.value || this.value || '' });
    }
}
